export default __webpack_public_path__ + "static/media/CBS-PDF-Icon-48.8860fd8b.svg";